import { FaPhoneAlt } from "react-icons/fa";
import { IoMail } from "react-icons/io5";
import ContactForm from "../forms/contactForm";
import CtaOffer from "../common/ctaOffer";

function Offer1WycinkaAlpinistyczna() {
  return (
    <>
      {/* HERO */}
      <section className="relative overflow-x-hidden flex flex-col lg:flex-row items-center justify-between lg:min-h-[60vh] p-6 lg:px-12 lg:pt-48 lg:pb-36 gap-6">
        <img
          className="absolute w-full h-full object-cover z-10 top-0 left-0"
          src="https://magazyn.drzewus.pl/wp-content/uploads/2025/02/pruning-trees-slaughter-of-a-poplar-seasonal-pru-2025-01-09-05-03-44-utc-Large.jpeg"
          alt="Wycinka alpinistyczna drzew - Drzewus"
        />
        <div className="w-full h-full object-cover z-20 absolute top-0 left-0 gradient-green-ltr"></div>
        <div className="flex flex-col items-start justify-center gap-2 z-30">
          <h1 className="text-3xl lg:text-6xl text-white text-left">
            Wycinka drzew metodą alpinistyczną i sekcyjną Gdańsk, Gdynia
          </h1>
          <h2 className="text-xl lg:text-3xl text-white text-left">
            Bezpieczne usuwanie drzew w trudnym terenie i przy budynkach
          </h2>
          <p className="text-white text-base lg:text-xl max-w-[850px] text-left">
            Drzewo przechylone nad dachem domu, ogrodzeniem lub linią energetyczną wymaga precyzji i doświadczenia. Wykonujemy bezpieczną wycinkę drzew metodą alpinistyczną (sekcyjną z linami) na terenie Gdańska, Gdyni, Wejherowa, Kartuz i Kaszub. Pielęgnujemy i usuwamy niebezpieczne konary, po czym oferujemy <a href="/oczyszczanie-terenu/frezowanie-pni" className="underline hover:opacity-80">frezowanie pniaków</a> oraz uprzątnięcie terenu.
          </p>
          <a href="#wiecej">
            <button className="button-yellow">Dowiedz się więcej</button>
          </a>
        </div>
        <div className="z-30 max-w-[500px] flex flex-col items-center justify-center">
          {" "}
          <ContactForm />
        </div>
      </section>
      {/* CONTENT */}
      <section
        id="wiecej"
        className="p-6 lg:px-24 lg:py-12 grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-12"
      >
        <div className="lg:col-span-1 flex flex-col gap-6">
          <div className="flex flex-col gap-2 p-6 rounded-xl bg-green w-full">
            <a
              href="#1"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Wycinka drzew przy budynkach i ogrodzeniach
            </a>
            <a
              href="#2"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Usuwanie drzew nad dachami i liniami energetycznymi
            </a>
            <a
              href="#3"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Bezpieczna wycinka drzew w zabudowie
            </a>
            <a
              href="#4"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Gdzie wycinamy drzewa – nasz obszar działania
            </a>
            <a
              href="#5"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Cena wycinki metodą alpinistyczną
            </a>
          </div>
          <CtaOffer />
        </div>
        <div className="lg:col-span-2 flex flex-col items-start justify-start text-left gap-2 content-offer">
          <h2 id="1">Wycinka drzew przy budynkach i ogrodzeniach</h2>
          <p>
            Metoda alpinistyczna to wycięcie drzewa po kawałku od góry. Taka
            metoda jest konieczna, jeśli wokół drzewa jest bardzo mało miejsca.
            Doświadczony drwal-alpinista potrafi tak wyciąć drzewo, by niczego
            nie uszkodziło. Jednak nie każdy może wycinać drzewa w taki sposób.
            Potrzebne są nie tylko specjalne umiejętności, ale też certyfikaty.
          </p>
          <p>
            Fachowiec od wycinki przy pomocy metody alpinistycznej to arborysta.
            Nasz pracownik posiada certyfikaty poświadczające uprawnienia do
            wycinki drzew tą metodą. Żeby zdobyć te uprawnienia, trzeba odbyć
            praktykę w takim ścinaniu drzew liczoną w setkach godzin. Dzięki
            temu masz pewność, że wycinkę drzewa przeprowadzi doświadczony
            fachowiec.
          </p>

          <h2 id="2">Usuwanie drzew nad dachami i liniami energetycznymi</h2>
          <p>
            Nie każde drzewo można wyciąć metodą klasyczną, czyli od dołu z
            poziomu gruntu. To, którą metodę trzeba zastosować, zależy od wielu
            czynników. Metoda alpinistyczna będzie konieczna w następujących
            przypadkach:
          </p>
          <ul>
            <li>drzewa w bardzo małej odległości od zabudowań</li>
            <li>duże drzewa na małej, zabudowanej działce</li>
            <li>drzewa bardzo wysokie</li>
            <li>drzewa w bezpośrednim sąsiedztwie linii elektrycznych</li>
            <li>drzewa w miejscach trudno dostępnych</li>
          </ul>
          <p>
            Nie sposób wymienić tu wszystkich przypadków, w których trzeba
            zastosować taką metodę. Posiadamy doświadczenie w ocenie, kiedy
            konieczna jest taka wycinka. Podaj nam jak najwięcej informacji, a
            podpowiemy Ci, czy takie rozwiązanie będzie niezbędne w Twoim
            przypadku.
          </p>
          <p>
            W innym razie możesz wybrać szybszą metodę klasyczną, która też jest
            w naszej ofercie. Jeśli nie jesteś pewny, która metoda będzie lepsza
            w Twoim wypadku, skontaktuj się z nami. Skorzystaj z naszego
            doświadczenia – chętnie doradzimy, która metoda będzie dla Ciebie
            najkorzystniejsza.
          </p>

          <h2 id="3">Bezpieczna wycinka drzew w zabudowie</h2>
          <p>
            Nie wymaga ona użycia podnośników i innego ciężkiego sprzętu.
            Zapewnia precyzyjną wycinkę drzew. Drzewo wycina się po kawałku.
            Najpierw wycina się koronę drzewa przez odcięcie wszystkich konarów.
            Na końcu zostaje wycięty pień. Dzięki temu nie musi być dużo wolnej
            przestrzeni do powalenia drzewa. Wszystko wycinamy w sposób
            kontrolowany. Nie musisz obawiać się uszkodzeń na swojej działce.
            Sąsiednie działki też będą bezpieczne.
          </p>

          <h2 id="4">Gdzie wycinamy drzewa – nasz obszar działania</h2>
          <p>
            Obsługujemy zarówno osoby prywatne, jak i klientów
            instytucjonalnych. Jeśli potrzebna jest Ci alpinistyczna wycinka
            drzew, pomorskie to region, w którym działamy. Usuwamy drzewa w
            Trójmieście i okolicach, ale nasze usługi oferujemy też na całym
            Pomorzu.
          </p>

          <h2 id="5">Cena wycinki metodą alpinistyczną</h2>
          <p>
            Cena zależy od kilku czynników. Ważna jest wielkość drzewa – jego
            wysokość i rozłożystość. Nie każdy potrafi to dobrze ocenić. Trudno
            jest zmierzyć wysokie drzewo. Dlatego podaj nam jak najwięcej
            szczegółów. Jeśli możesz, prześlij nam zdjęcie drzewa do wycinki.
            Przygotujemy dla Ciebie bezpłatną wycenę. Jeśli będziemy potrzebować
            więcej informacji, to w ciągu kilku dni umówimy się na bezpłatną
            wizję lokalną. Dzięki temu podamy Ci dokładną cenę naszej usługi.
          </p>
          <p>
            Mamy w naszej ekipie dendrologa i ornitologa, którzy pomagają w
            uzyskaniu pozwolenia na wycięcie drzewa. Oferujemy załatwienie
            wszystkich formalności, wycinkę oraz uprzątnięcie placu po wycince.
            Dzięki nam pozbędziesz się problemu z niepotrzebnym drzewem.
          </p>
          <p>
            Nie czekaj – już dziś umów się na wycinkę. Zacznij działać, zanim
            drzewo zacznie zagrażać bezpieczeństwu lub wyglądowi otoczenia. Z
            naszą pomocą usuniesz je szybko i skutecznie.
          </p>
        </div>
      </section>
      {/* PORTFOLIO */}
      <section className="p-6 lg:px-24 lg:py-12 flex flex-col gap-6">
        <div className="flex flex-col items-center justify-center mb-6">
          <h2 className="uppercase color-yellow text-xl text-center">
            Nasze realizacje
          </h2>
          <h3 className="text-3xl lg:text-5xl color-green text-center">
            Spójrz jak pomogliśmy<br></br>
            <span className="color-yellow">naszym Klientom</span>
          </h3>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-2">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/06/AdobeStock_196692604-Large.jpeg"
              alt="Wycinka alpinistyczna drzew na wysokości - realizacja Drzewus nr 1"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-2">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/06/AdobeStock_235938295-Large.jpeg"
              alt="Wycinka alpinistyczna - arborystyka i prace na wysokości nr 2"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-1">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/06/AdobeStock_677746691-Large.jpeg"
              alt="Wycinka alpinistyczna - prace arborystyczne nr 3"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-1">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/07/wycinka-alpinistyczna-1.jpeg"
              alt="Wycinka alpinistyczna - realizacja Drzewus nr 4"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-2">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/07/wycinka-alpinistyczna-2.jpeg"
              alt="Wycinka alpinistyczna - realizacja Drzewus nr 5"
              className="h-full object-cover w-full"
            />
          </div>
        </div>
      </section>
    </>
  );
}

export default Offer1WycinkaAlpinistyczna;